import axios from 'axios';
import store from '@/store/index';

const {
  VUE_APP_PROFILE_PROXY_PATH: profileProxyPath,
  VUE_APP_PROFILE_PATH: profilePath,
  VUE_APP_USER_BEHAVIOR_LOG_SERVICE_PROXY_PATH: userBehaviorLogServiceProxyPath,
  VUE_APP_USER_BEHAVIOR_LOG_SERVICE_LOG_PATH: userBehaviorLogServiceLogPath,
} = process.env;

export default {
  getMemberInfo() {
    // @const {Object} data 會員資訊參數
    const data = {
      // eslint-disable-next-line max-len
      fields:
          '{ pCoin nickname image bio account { cellphone { number } } levelInfo{ level levelExp levelExpToNext } }',
    };
    const tokens = store.getters.getTokens;
    const params = tokens ? {
      headers: {
        Authorization: `Bearer ${tokens.at}`,
      },
    } : {};
    return axios.post(`${profileProxyPath}${profilePath}/graphql/query/member`, data, params);
  },
  addElkLog(data) {
    const tokens = store.getters.getTokens;
    axios.post(`${userBehaviorLogServiceProxyPath}${userBehaviorLogServiceLogPath}`, data, {
      headers: {
        // ...headers,
        ...(tokens ? { Authorization: `Bearer ${tokens.at}` } : {}),
      },
    });
  },
};
